export default __webpack_public_path__ + "static/media/profile2.d95a1ffb.png";